import React from 'react';
import '../App.css';
import core from './images/core.png';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function Features() {
  const { ref, inView } = useInView({ triggerOnce: true , threshold: 0.3 });

  return (
    <>
      <section id='features'>
        <div className="feature-section d-flex flex-column text-light">
          <h1 className="gradient-text mt-5 text-center">Core Feature</h1>

          <div className="container mt-4">
            <div className="container text-center mt-5" ref={ref}>

              {/* Row 1 */}
              <motion.div
                className="row mb-3 justify-content-center"
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.0, ease: "easeOut" }}
              >
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">1. Production Overview Dashboard</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">2. Inventory Management</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">3. Planning & Scheduling</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">4. Sales & Quotation Management</p></div>
              </motion.div>

              {/* Row 2 */}
              <motion.div
                className="row mb-3 justify-content-center"
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
              >
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">5. Invoice Generation</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">6. BOM File Upload</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">7. Work Tracking & Status Updates</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">8. Subcontractor Management</p></div>
              </motion.div>

              {/* Row 3 */}
              <motion.div
                className="row mb-3 justify-content-center"
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
              >
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">9. Machine QR</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">10. User & Role Management</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">11. Department & Machine Setup</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">12. Analytics & Reports</p></div>
              </motion.div>

              {/* Row 4 */}
              <motion.div
                className="row mb-3 justify-content-center"
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
              >
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">13. Order Change & Management Console</p></div>
                <div className="col-md-3 col-sm-6 mb-2"><p className="feature-box mb-0">14. Secure Cloud Access</p></div>
              </motion.div>

            </div>

            {/* Image Section */}
            <div className="text-center mt-5">
              <img src={core} alt="Core" className="img-fluid core-img" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
